/**
 * Cleans up a string for search purposes (making them kinda fuzzy).
 * @param string Original string
 * @returns Cleaned up string.
 */
export const searchCleanup = (string: string) => string.replace(/\s*/gu, "").toLocaleLowerCase();
